$(document).ready(function () {
	$('header').addClass('header--catalog');
	$('.header__category').css('display', 'none');
	$('.header__filter-wrapper').css('display', 'none');
// $('.header__carousel').slick({
// 	arrows: true,
// 	slidesToScroll: 1,
// 	infinite: false,
// 	variableWidth: true
// });
	const da = new DynamicAdapt("max");
	da.init();

	let arrayDetach = [];
	let catalogRowChildArray = $(".new__row").children().clone(true).toArray();
	let catalogRowArray = $(".new__row").toArray();
	var rowSeo;
	$('.zoom-1').on('click', () => {

		let i = 0;
		let catalogContentChild = $(".catalog__content").children().toArray();
		catalogContentChild.forEach(function (element, index, array) {
			if (typeof $(element).data('type') !== 'undefined' && typeof $(element).data('type-pos') !== 'undefined') {
				arrayDetach[i] = $(element).clone(true);
				i++

			}
		});
		i = 0;

		// console.log(arrayDetach);

		$('.catalog__content').empty();
		arrayDetach.forEach(function (element, index, array) {
			let dataType = $(element).data('type');
			let dataTypePos = $(element).data('type-pos');
			//
			// console.log("type: " + dataType + "pos: " + dataTypePos);

			if ($('.catalog__content').find(`.catalog__row[data-type="${dataType}"][data-type-pos="${dataTypePos}"]`).length == 0) {
				// $('.catalog__content').find(`.catalog__row[data-type="2"][data-type-pos="2"]`)
				d = document.createElement('div');
				$(d).addClass(`catalog__row row-type-${dataType}`)
					.attr('data-type', dataType)
					.attr('data-type-pos', dataTypePos)
					.append(element)
					.appendTo($(".catalog__content"));
				if (index === 0) {
					if (rowSeo != undefined)
						$(rowSeo[0]).appendTo($(".catalog__content"));
					rowSeo = undefined;
				}

			} else {
				$('.catalog__content').find(`.catalog__row[data-type="${dataType}"][data-type-pos="${dataTypePos}"]`).append(element)
			}
			$(element).removeClass('zoom2');
			$(element).removeClass('zoom3');

		});

		// let obj = {
		// 	1:[],
		// 	1:[],
		// 	1:[],
		// 	1:[],
		// 	1:[],
		// 	1:[],
		// 	1:[],
		// 	1:[],
		// };


		// arrayDetach.forEach((element, index, array) => {
		// 	console.log($(element).attr('data-id'));
		// });
	});
	$('.zoom-2').on('click', () => {
		if ($('.row-type-seo-info').length > 0)
			rowSeo = $('.row-type-seo-info').detach();
		let rowItem = $(".row__item").toArray();
		$('.row-type-seo-info').addClass('zoom2');
		rowItem.forEach(function (element, index, array) {
			$(element).addClass('zoom2');
			$(element).removeClass('zoom3');
			let parentType = $(element).parent().attr('data-type');
			let parentTypePos = $(element).parent().attr('data-type-pos');
			$(element).attr('data-type', parentType);

			$(element).attr('data-type-pos', parentTypePos);


		});
		if ($('.catalog__row').length > 1) {
			$(".row__item").unwrap();

		}

	});
	$('.zoom-3').on('click', () => {
		if ($('.row-type-seo-info').length > 0)
			rowSeo = $('.row-type-seo-info').detach();
		let rowItem = $(".row__item").toArray();
		$('.row-type-seo-info').addClass('zoom3');
		rowItem.forEach(function (element, index, array) {
			$(element).addClass('zoom3');
			$(element).removeClass('zoom2');
			let parentType = $(element).parent().attr('data-type');
			let parentTypePos = $(element).parent().attr('data-type-pos');
			$(element).attr('data-type', parentType);

			$(element).attr('data-type-pos', parentTypePos);


		});
		if ($('.catalog__row').length > 1) {
			$(".row__item").unwrap();

		}
		console.log($('.catalog__row'));
	});
	// $.fn.rangeSlider = function (n) {
	// 	if (!n || typeof n !== 'number') {
	// 		console.log(new Error('You need to tell $.rangeSlider how many numbers are in the slider.'));
	// 		return false;
	// 	}
	//
	// 	var template =
	// 		'<div class="RangeSlider_ClickArea">' +
	// 		'<div class="RangeSlider_Track">' +
	// 		'<div class="RangeSlider_TrackFill">' +
	// 		'<div class="RangeSlider_Thumb"></div>' +
	// 		'</div>' +
	// 		'</div>' +
	// 		'<div class="RangeSlider_Points">' +
	// 		'{{points}}' +
	// 		'</div>' +
	// 		'</div>';
	// 	this.append(template.replace('{{points}}', (() => {
	// 		var points = '';
	// 		for (var i = 0; i < (n + 1); i++) {
	// 			points += '<div class="RangeSlider_Point">{{n}}</div>'.replace('{{n}}', i);
	// 		}
	// 		return points;
	// 	})()));
	//
	// 	var $this = this,
	// 		$sliderThumnb = $this.find('.RangeSlider_Thumb'),
	// 		$sliderTrack = $this.find('.RangeSlider_Track'),
	// 		$sliderTrackFill = $this.find('.RangeSlider_TrackFill'),
	// 		$clickArea = $this.find('.RangeSlider_ClickArea'),
	// 		$sliderPoints = $this.find('.RangeSlider_Point')
	// 	value = 0;
	//
	//
	// 	// bind events when inititiated
	// 	$clickArea.on(' mousedown touchend', function (e) {
	// 		// stop animations
	//
	// 		$sliderTrackFill.addClass('RangeSlider_TrackFill-stopAnimation');
	// 		// find out where in the clickarea the user clicked
	// 		var curPos = getCursorPositionRelativeToClickArea(e);
	// 		// get the new fill width based on cursor pos
	// 		var newFillWidth = findTrackFillWidthFromCoordinates(curPos);
	// 		// update the track fill (but not the value)
	// 		setTrackFill(newFillWidth);
	// 		// bind drag events etc.
	// 		setupDrag(curPos);
	//
	//
	// 		if ($('.RangeSlider_Point.active')[0].innerText === '0') {
	// 			let i = 0;
	// 			let catalogContentChild = $(".catalog__content").children().toArray();
	// 			catalogContentChild.forEach(function (element, index, array) {
	// 				if (typeof $(element).data('type') !== 'undefined' && typeof $(element).data('type-pos') !== 'undefined') {
	// 					arrayDetach[i] = $(element).clone(true);
	// 					i++
	//
	// 				}
	// 			});
	// 			i = 0;
	//
	// 			// console.log(arrayDetach);
	//
	// 			$('.catalog__content').empty();
	// 			arrayDetach.forEach(function (element, index, array) {
	// 				let dataType = $(element).data('type');
	// 				let dataTypePos = $(element).data('type-pos');
	// 				//
	// 				// console.log("type: " + dataType + "pos: " + dataTypePos);
	//
	// 				if ($('.catalog__content').find(`.catalog__row[data-type="${dataType}"][data-type-pos="${dataTypePos}"]`).length === 0) {
	// 					// $('.catalog__content').find(`.catalog__row[data-type="2"][data-type-pos="2"]`)
	// 					d = document.createElement('div');
	// 					$(d).addClass(`catalog__row row-type-${dataType}`)
	// 						.attr('data-type', dataType)
	// 						.attr('data-type-pos', dataTypePos)
	// 						.append(element)
	// 						.appendTo($(".catalog__content"));
	// 					if (index === 0) {
	// 						if (rowSeo != undefined)
	// 							$(rowSeo[0]).appendTo($(".catalog__content"));
	// 						rowSeo = undefined;
	// 					}
	//
	// 				} else {
	// 					$('.catalog__content').find(`.catalog__row[data-type="${dataType}"][data-type-pos="${dataTypePos}"]`).append(element)
	// 				}
	// 				$(element).removeClass('zoom2');
	// 				$(element).removeClass('zoom3');
	//
	// 			});
	//
	// 			// let obj = {
	// 			// 	1:[],
	// 			// 	1:[],
	// 			// 	1:[],
	// 			// 	1:[],
	// 			// 	1:[],
	// 			// 	1:[],
	// 			// 	1:[],
	// 			// 	1:[],
	// 			// };
	//
	//
	// 			// arrayDetach.forEach((element, index, array) => {
	// 			// 	console.log($(element).attr('data-id'));
	// 			// });
	// 		} else if ($('.RangeSlider_Point.active')[0].innerText === '1') {
	// 			if ($('.row-type-seo-info').length > 0)
	// 				rowSeo = $('.row-type-seo-info').detach();
	// 			console.log(rowSeo)
	// 			let rowItem = $(".row__item").toArray();
	// 			$('.row-type-seo-info').addClass('zoom2');
	// 			rowItem.forEach(function (element, index, array) {
	// 				$(element).addClass('zoom2');
	// 				$(element).removeClass('zoom3');
	// 				let parentType = $(element).parent().attr('data-type');
	// 				let parentTypePos = $(element).parent().attr('data-type-pos');
	// 				$(element).attr('data-type', parentType);
	//
	// 				$(element).attr('data-type-pos', parentTypePos);
	//
	//
	// 			});
	// 			if ($('.catalog__row').length > 1) {
	// 				$(".row__item").unwrap();
	//
	// 			}
	//
	// 		} else {
	// 			if ($('.row-type-seo-info').length > 0)
	// 				rowSeo = $('.row-type-seo-info').detach();
	// 			let rowItem = $(".row__item").toArray();
	// 			$('.row-type-seo-info').addClass('zoom3');
	// 			rowItem.forEach(function (element, index, array) {
	// 				$(element).addClass('zoom3');
	// 				$(element).removeClass('zoom2');
	// 				let parentType = $(element).parent().attr('data-type');
	// 				let parentTypePos = $(element).parent().attr('data-type-pos');
	// 				$(element).attr('data-type', parentType);
	//
	// 				$(element).attr('data-type-pos', parentTypePos);
	//
	//
	// 			});
	// 			if ($('.catalog__row').length > 1) {
	// 				$(".row__item").unwrap();
	//
	// 			}
	// 			console.log($('.catalog__row'));
	// 		}
	// 	});
	// 	// cancel everything when done
	// 	$clickArea.on('mouseup ', function (e) {
	// 		// start animations
	// 		$sliderTrackFill.removeClass('RangeSlider_TrackFill-stopAnimation');
	// 		// stop the dragging event
	// 		tearDownDrag();
	// 		// find nearest number based on current position
	// 		value = findValueBasedOnTrackFillWidth();
	// 		// set the new value
	// 		setValue(value);
	// 		$('.RangeSlider_Point').each((index, value) => {
	// 			if ($(value).hasClass('active')) {
	// 				if (index === 0) {
	// 					let i = 0;
	// 					let catalogContentChild = $(".catalog__content").children().toArray();
	//
	// 					catalogContentChild.forEach(function (element, index, array) {
	// 						$(element).css('opacity', '0');
	// 						if (typeof $(element).data('type') !== 'undefined' && typeof $(element).data('type-pos') !== 'undefined') {
	// 							arrayDetach[i] = $(element).clone(true);
	// 							i++
	//
	// 						}
	// 					});
	// 					i = 0;
	//
	// 					setTimeout(() => {
	// 						$('.catalog__content').empty();
	// 						arrayDetach.forEach(function (element, index, array) {
	// 							let dataType = $(element).data('type');
	// 							let dataTypePos = $(element).data('type-pos');
	// 							if ($('.catalog__content').find(`.catalog__row[data-type="${dataType}"][data-type-pos="${dataTypePos}"]`).length == 0) {
	// 								// $('.catalog__content').find(`.catalog__row[data-type="2"][data-type-pos="2"]`)
	// 								d = document.createElement('div');
	// 								$(d).addClass(`catalog__row row-type-${dataType}`)
	// 									.attr('data-type', dataType)
	// 									.attr('data-type-pos', dataTypePos)
	// 									.append(element)
	// 									.appendTo($(".catalog__content"));
	// 								if (index === 0) {
	// 									if (rowSeo != undefined)
	// 										$(rowSeo[0]).appendTo($(".catalog__content"));
	// 									rowSeo = undefined;
	// 								}
	//
	// 							} else {
	// 								$('.catalog__content').find(`.catalog__row[data-type="${dataType}"][data-type-pos="${dataTypePos}"]`).append(element)
	// 							}
	// 							$(element).removeClass('zoom2');
	// 							$(element).removeClass('zoom3');
	//
	// 							setTimeout(() => {
	// 								arrayDetach.forEach(function (element, index, array) {
	// 									$(element).css('opacity', '1');
	// 								});
	// 							}, 200)
	// 						});
	//
	// 					}, 300)
	//
	// 				} else if (index === 1) {
	// 					if ($('.row-type-seo-info').length > 0)
	// 						rowSeo = $('.row-type-seo-info').detach();
	// 					let rowItem = $(".row__item").toArray();
	//
	// 					rowItem.forEach(function (element, index, array) {
	// 						// $(element).addClass( "hidden" );
	// 						$(element).css('opacity', '0');
	// 					});
	//
	// 					setTimeout(() => {
	// 						$('.row-type-seo-info').addClass('zoom2');
	//
	//
	// 						rowItem.forEach(function (element, index, array) {
	// 							$(element).addClass('zoom2');
	// 							$(element).removeClass('zoom3');
	// 							let parentType = $(element).parent().attr('data-type');
	// 							let parentTypePos = $(element).parent().attr('data-type-pos');
	// 							$(element).attr('data-type', parentType);
	//
	// 							$(element).attr('data-type-pos', parentTypePos);
	//
	//
	// 						});
	//
	//
	// 						if ($('.catalog__row').length > 1) {
	// 							$(".row__item").unwrap();
	//
	// 						}
	//
	// 						setTimeout(() => {
	// 							rowItem.forEach(function (element, index, array) {
	// 								$(element).css('opacity', '1');
	// 							});
	// 						}, 200)
	//
	//
	// 					}, 300);
	//
	//
	// 				} else {
	// 					if ($('.row-type-seo-info').length > 0)
	// 						rowSeo = $('.row-type-seo-info').detach();
	// 					let rowItem = $(".row__item").toArray();
	//
	// 					rowItem.forEach(function (element, index, array) {
	// 						// $(element).addClass( "hidden" );
	// 						$(element).css('opacity', '0');
	// 					});
	// 					setTimeout(() => {
	// 						$('.row-type-seo-info').addClass('zoom3');
	//
	//
	// 						rowItem.forEach(function (element, index, array) {
	// 							$(element).addClass('zoom3');
	// 							$(element).removeClass('zoom2');
	// 							let parentType = $(element).parent().attr('data-type');
	// 							let parentTypePos = $(element).parent().attr('data-type-pos');
	// 							$(element).attr('data-type', parentType);
	//
	// 							$(element).attr('data-type-pos', parentTypePos);
	//
	//
	// 						});
	//
	// 						if ($('.catalog__row').length > 1) {
	// 							$(".row__item").unwrap();
	//
	// 						}
	//
	// 						setTimeout(() => {
	// 							rowItem.forEach(function (element, index, array) {
	// 								$(element).css('opacity', '1');
	// 							});
	// 						}, 300)
	//
	//
	// 					}, 300);
	//
	// 				}
	// 			}
	// 		})
	// 	});
	//
	// 	function setupDrag(coordinates) {
	// 		$clickArea.on('mousemove.drag touchmove  ', function (e) {
	// 			// console.log(e);
	//
	// 			// find out where in the clickarea the cursor is
	// 			var curPos = getCursorPositionRelativeToClickArea(e);
	// 			// move the track to this point (but don't update the value)
	// 			var newFillWidth = findTrackFillWidthFromCoordinates(curPos);
	// 			setTrackFill(newFillWidth);
	// 			// this may become expensive and is not important
	// 			// for functionality but is for UX
	// 			var newValue = findValueBasedOnTrackFillWidth();
	//
	// 			highlightValue(newValue);
	//
	// 			// console.log(newValue);
	//
	//
	// 		});
	// 	}
	//
	// 	function tearDownDrag() {
	// 		$clickArea.off('mousemove.drag');
	// 	}
	//
	// 	function getCursorPositionRelativeToClickArea(mouseEvent) {
	// 		var clickAreaOffset = $clickArea.offset(),
	// 			clickAreaPadding = $sliderTrack.position().left;
	// 		var curPos = {
	// 			x: (mouseEvent.pageX - clickAreaOffset.left - clickAreaPadding) || (mouseEvent.changedTouches[0].pageX - clickAreaOffset.left - clickAreaPadding),
	// 			y: (mouseEvent.pageY - clickAreaOffset.top) || (mouseEvent.changedTouches[0].pageY - clickAreaOffset.top)
	// 		}
	// 		return curPos;
	// 	}
	//
	// 	function findTrackFillWidthFromCoordinates(coordinates) {
	// 		var totalWidth = $sliderTrack.width(),
	// 			width = (coordinates.x / totalWidth) * 100;
	// 		if (width > 100) {
	// 			width = 100;
	// 		}
	// 		if (width < 0) {
	// 			width = 0;
	// 		}
	// 		return width;
	// 	}
	//
	// 	function findValueBasedOnTrackFillWidth() {
	// 		// ** suggestions to improve this method are welcome **
	// 		var trackFillWidth = $sliderTrackFill.width(),
	// 			fullWidth = $sliderTrack.width(),
	// 			widthAsPercentage = (trackFillWidth / fullWidth) * 100;
	// 		// for each number in the slider
	// 		// find out what percentage width
	// 		// we would need to set that number
	// 		var valuePercentages = [];
	// 		for (var i = 0, fixedWidth; i < (n + 1); i++) {
	// 			fixedWidth = (fullWidth / n) * i;
	// 			valuePercentages.push((fixedWidth / fullWidth) * 100);
	// 		}
	// 		// now find out which one of those numbers
	// 		// is closest to the width that is already set
	// 		var placeholderValue = 999999999999999,
	// 			index = 0;
	// 		for (var i = 0; i < valuePercentages.length; i++) {
	// 			var difference = Math.abs(widthAsPercentage - valuePercentages[i]);
	// 			if (difference < placeholderValue) {
	// 				placeholderValue = difference;
	// 				index = i;
	// 			}
	// 		}
	// 		return index;
	// 	}
	//
	// 	function findTrackFillWidthBasedOnValue(val) {
	// 		var fullWidth = $sliderTrack.width(),
	// 			newWidth = (fullWidth / n) * val,
	// 			newPercentageWidth = (newWidth / fullWidth) * 100;
	// 		return newPercentageWidth;
	// 	}
	//
	// 	function highlightValue(val) {
	// 		$sliderPoints.removeClass('active');
	// 		$sliderPoints.eq(val).addClass('active');
	// 	}
	//
	// 	function setTrackFill(width) {
	// 		$sliderTrackFill.width(width + '%');
	// 	}
	//
	// 	function setValue(val) {
	// 		var newWidth = findTrackFillWidthBasedOnValue(val);
	// 		setTrackFill(newWidth);
	// 		value = val;
	// 		highlightValue(val);
	// 	}
	//
	// 	/**
	// 	 *  Public API
	// 	 */
	//
	// 	// get/set slider value
	// 	this.value = function (num) {
	// 		if (typeof num === 'number') {
	// 			setValue(num);
	// 			return $this;
	// 		} else {
	// 			return value;
	// 		}
	// 	}
	// 	return $this;
	// }
	// var range4 = $('#zoom').rangeSlider(2);
	// $('.RangeSlider_Points').children().toArray()[0].classList.add('active');

	var rangeInput = document.querySelector('.range-input');

// Change input value on label click
	const labels = document.querySelectorAll('.range-labels li');
	labels.forEach(el => el.addEventListener('click', event => {
		const index = [...el.parentElement.children].indexOf(el)
		rangeInput.value = index + 1;
	}));

	let years = [1, 2, 3];

	function getClosest(arr, val) {
		return arr.reduce(function (prev, curr) {
			return (Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev);
		});
	}

	document.querySelector(".range-input").addEventListener("change", function () {
		let closest = getClosest(years, this.value);
		this.value = closest;
		console.log(this.value);
		if (this.value == 1) {

			if ($('.new__row').length > 0)
				return;
			let i = 0;
			let catalogContentChild = $(".new__content").children().toArray();

			catalogContentChild.forEach(function (element, index, array) {
				$(element).css('opacity', '0');
				if (typeof $(element).data('type') !== 'undefined' && typeof $(element).data('type-pos') !== 'undefined') {
					arrayDetach[i] = $(element).clone(true);
					i++

				}
			});
			i = 0;

			setTimeout(() => {
				$('.new__content').empty();
				arrayDetach.forEach(function (element, index, array) {
					let dataType = $(element).data('type');
					let dataTypePos = $(element).data('type-pos');
					if ($('.new__content').find(`.new__row[data-type="${dataType}"][data-type-pos="${dataTypePos}"]`).length == 0) {
						// $('.catalog__content').find(`.catalog__row[data-type="2"][data-type-pos="2"]`)
						d = document.createElement('div');
						$(d).addClass(`new__row row-type-${dataType}`)
							.attr('data-type', dataType)
							.attr('data-type-pos', dataTypePos)
							.append(element)
							.appendTo($(".new__content"));
						if (index === 0) {
							if (rowSeo != undefined)
								$(rowSeo[0]).appendTo($(".new__content"));
							rowSeo = undefined;
						}

					} else {
						$('.new__content').find(`.new__row[data-type="${dataType}"][data-type-pos="${dataTypePos}"]`).append(element)
					}
					$(element).removeClass('zoom2');
					$(element).removeClass('zoom3');

					setTimeout(() => {
						arrayDetach.forEach(function (element, index, array) {
							$(element).css('opacity', '1');
						});
					}, 200)
				});

			}, 300)
		} else if (this.value == '2') {
			if ($('.row-type-seo-info').length > 0)
				rowSeo = $('.row-type-seo-info').detach();
			let rowItem = $(".row__item").toArray();

			rowItem.forEach(function (element, index, array) {
				// $(element).addClass( "hidden" );
				$(element).css('opacity', '0');
			});

			setTimeout(() => {
				$('.row-type-seo-info').addClass('zoom2');


				rowItem.forEach(function (element, index, array) {
					$(element).addClass('zoom2');
					$(element).removeClass('zoom3');
					let parentType = $(element).parent().attr('data-type');
					let parentTypePos = $(element).parent().attr('data-type-pos');
					$(element).attr('data-type', parentType);

					$(element).attr('data-type-pos', parentTypePos);


				});


				if ($('.new__row').length > 1) {
					$(".row__item").unwrap();

				}

				setTimeout(() => {
					rowItem.forEach(function (element, index, array) {
						$(element).css('opacity', '1');
					});
				}, 200)


			}, 300);
		} else {
			if ($('.row-type-seo-info').length > 0)
				rowSeo = $('.row-type-seo-info').detach();
			let rowItem = $(".row__item").toArray();

			rowItem.forEach(function (element, index, array) {
				// $(element).addClass( "hidden" );
				$(element).css('opacity', '0');
			});
			setTimeout(() => {
				$('.row-type-seo-info').addClass('zoom3');


				rowItem.forEach(function (element, index, array) {
					$(element).addClass('zoom3');
					$(element).removeClass('zoom2');
					let parentType = $(element).parent().attr('data-type');
					let parentTypePos = $(element).parent().attr('data-type-pos');
					$(element).attr('data-type', parentType);

					$(element).attr('data-type-pos', parentTypePos);


				});

				if ($('.new__row').length > 1) {
					$(".row__item").unwrap();

				}

				setTimeout(() => {
					rowItem.forEach(function (element, index, array) {
						$(element).css('opacity', '1');
					});
				}, 300)


			}, 300);
		}
	});


});


